//class to force "enter" keypress to submit
//this class can be added when the last form element to be selected might be a select
$(document).on('keydown', 'select.forceSubmit', function (e) {
  if (e.which == 13) {
    $(this).parents('form').submit();
  }
});
